import React from "react";
import { FactBlockResponseModel } from "@models/strapi-components/fact-block";
import Title from "@components/common/Title";
import Tile from "@components/common/Tile";
import VizWrapper from "@components/common/Base/VizWrapper";

export interface FactBlockPropsModel {
  componentData: FactBlockResponseModel;
}
const FactBlock: React.FunctionComponent<FactBlockPropsModel> = (props) => {
  const {
    title,
    subTitle,
    statOneTitle,
    statTwoTitle,
    statOneDescription,
    statTwoDescription,
    bgColor,
  } = props?.componentData ?? {};

  return (
    <VizWrapper
      className="flex flex-col-reverse md:flex-row px-8 lg:px-[180px] gap-8 md:gap-[61px] lg:gap-[91] items-center md:items-stretch"
      style={{ backgroundColor: bgColor }}
    >
      <div className="flex flex-col xl:flex-row gap-4 xl:gap-10 px-4 md:px-0 items-center">
        <Tile
          data={{ title: statOneTitle, subTitle: statOneDescription }}
          wrapperClassName="xl:basis-1/2 xl:my-0 max-w-[60%] md:max-w-[100%] h-full p-5 md:p-8 block"
          titleClassName="mb-3"
        />
        <Tile
          data={{ title: statTwoTitle, subTitle: statTwoDescription }}
          wrapperClassName="xl:basis-1/2 max-w-[60%] md:max-w-[100%] h-full p-5 md:p-8 block"
          titleClassName="mb-3"
        />
      </div>
      <div className="max-w-[415px] flex flex-col justify-center ">
        <Title
          titleText={title}
          variant="h2"
          className="text-center md:text-left"
        />
        <Title
          titleText={subTitle}
          variant="paragraph"
          className="text-center md:text-left"
        />
      </div>
    </VizWrapper>
  );
};

export default FactBlock;
